import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from 'app/app.service';

@Injectable({
  providedIn: 'root'
})
export class VendaPublicaService {

  private readonly urlAPI: string;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly appService: AppService,
  ) {
    this.urlAPI = `${this.appService.getUrlAPINest()}inclusao-pf/`;
  }

  async getVendaPublicaPorToken(token: string): Promise<any> {
    try {
      return await this.httpClient
        .get<any>(`${this.urlAPI}vendas/publico/${encodeURIComponent(token)}`)
        .toPromise();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}
